import React, {useEffect, useState, useContext} from "react";
import Sidebar from "../components/sidebar";
import Navbar from "../components/navbar";
import {useHistory} from "react-router-dom";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import route from "./routes";
import {useSelector, useDispatch} from "react-redux";
// import {get_all_companies} from "../redux/company";
// import {get_all_establishments} from "../redux/establishment";
// import {
//     getAllEmployees,
//     getLogsEmployees,
// } from "../redux/employees";
// import {getAllSuppliers} from "../redux/supplier";
import {
    SocketContext, TYPE_CREATE_MAINTENANCE, TYPE_CREATE_NOVELTY_VEHICLE_MAINTENANCE, TYPE_CREATE_PURCHASE,
    TYPE_CREATE_SHIPPING_REQUEST, TYPE_CREATE_VACANCIES, TYPE_CREATE_VEHICLE_MAINTENANCE,
    TYPE_UPDATE_MAINTENANCE, TYPE_UPDATE_MONITOREO, TYPE_UPDATE_NOVELTY_VEHICLE_MAINTENANCE, TYPE_UPDATE_PURCHASE,
    TYPE_UPDATE_SHIPPING_REQUEST, TYPE_UPDATE_VACANCIES, TYPE_UPDATE_VEHICLE_MAINTENANCE, TYPE_UPDATE_PERSONAL_DEPARTURES
} from "../config/ws-client";
// import {get_all_visitants} from "../redux/visitant";
// import {
//     // get_all_users,
//     // get_all_groups,
//     get_all_permisions,
// } from "../redux/users";
// import {get_all_general_settings} from "../redux/base";
// import {getAllJobs} from "../redux/jobs";
import {getAllVisits} from "../redux/visits";
import {getAllDepartures, getAllDeparturesPersonal} from "../redux/departures";
import {getAllVisitsAndDepartures} from "../redux/monitoringDeparturesAndVisits.js";
import {getAllIncome} from "../redux/income.js";
// import {get_all_zones} from "../redux/zones";
import {toast} from "react-toastify";
import {save_notification} from "../redux/visits";
// import {getAllEmailSetting} from "../redux/email_setting.js";
import {
    TYPE_UPDATE_MESSAGE,
    TYPE_CREATE_MESSAGE,
    TYPE_CREATE_DEPARTURE,
    TYPE_UPDATE_DEPARTURE,
    TYPE_INCOME_CREATE_MESSAGE,
    TYPE_INCOME_UPDATE_MESSAGE,
    TYPE_UPDATE_CUSTODY,
    TYPE_CREATE_CUSTODY
} from "../config/ws-client";
import {getAllCustody} from "../redux/custody";
import {getAllShippingRequest} from "../redux/shipping_request";
import {getAllMaintenance} from "../redux/maintenance";
import {getAllPurchase} from "../redux/purchases";
import {getAllNoveltyVehicleMaintenance} from "../redux/novelty_maintenance_vehicle";
import {getAllVehicle} from "../redux/vehicles";
import {getAllVacancies} from "../redux/vacancies";
// import {getAllReasonDecline} from "../redux/reason_decline.js";
// import {get_all_bank} from "../redux/banks.js";
// import {getAllReasonDismissal} from "../redux/reason_dismissal.js";
// // import {get_all_form} from "../redux/forms";
// import {get_all_section} from "../redux/sections";
// import {get_all_field_types} from "../redux/field_types";

const Index = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const _data_login = useSelector((state) => state.users_module.login);
    const _session_data = useSelector(
        (state) => state.users_module._session_data
    );
    const [permisos, setPermissions] = useState([]);
    const {socket} = useContext(SocketContext);
    const _get_notification = useSelector(
        (state) => state.visits_module._get_notification
    );

    const [token, setToken] = useState("");

    const request_exit = useSelector((state) =>
        state.users_module._session_data.data.grupo_permiso?.permisos.find(
            (obj) => obj.codigo === "request_exit"
        )
    );

    const response_exit = useSelector((state) =>
        state.users_module._session_data.data.grupo_permiso?.permisos.find(
            (obj) => obj.codigo === "response_exit"
        )
    );

    const aprove_departures = useSelector((state) =>
        state.users_module._session_data.data.grupo_permiso?.permisos.find(
            (obj) => obj.codigo === "aprove_departures"
        )
    );


    /* const view_employeedepartures = useSelector((state) =>
      state.users_module._session_data.data.grupo_permiso?.permisos.find(
        (obj) => obj.codigo === "view_employeedepartures"
      )
    ); */

    const userEstablishmentsList = useSelector(
        (state) => state.users_module._session_data.data
    );
    // const userEstablishmentsStatus = useSelector(
    //     (state) => state.users_module._session_data.status
    // );


    const audio = new Audio("/base/assets/audio/audio.mp3");


    useEffect(() => {
        if (JSON.stringify(_session_data.data) !== "{}") {
            if (_session_data.data.grupo_permiso) {
                if (_session_data.data.grupo_permiso.permisos) {
                    setPermissions(_session_data.data.grupo_permiso.permisos);
                }
            }
        }
    }, [_session_data]);

    useEffect(() => {
        if (_data_login.status >= 200) {
            /* if (permisos.filter(x => x.codigo === 'view_company').length > 0) {
                dispatch(get_all_companies(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_establishments').length > 0) {
                dispatch(get_all_establishments(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_employees').length > 0) {
                dispatch(getAllEmployees(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_employees').length > 0) {
                dispatch(getLogsEmployees(_data_login.data.token, '', 1));
            }
            if (permisos.filter(x => x.codigo === 'view_supplier').length > 0) {
                dispatch(getAllSuppliers(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_visitant').length > 0) {
                dispatch(get_all_visitants(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_user').length > 0) {
                dispatch(get_all_users(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_job').length > 0) {
                dispatch(getAllJobs(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_group').length > 0) {
                dispatch(get_all_groups(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_user').length > 0) {
                dispatch(get_all_permisions(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_zones').length > 0) {
                // dispatch(getAllEmailVisits(_data_login.data.token))
                dispatch(get_all_zones(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_emailsettings').length > 0) {
                dispatch(getAllEmailSetting(_data_login.data.token));
            }

            if (permisos.filter(x => x.codigo === 'view_reasonsdecline').length > 0) {
                dispatch(getAllReasonDecline(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_banks').length > 0) {
                dispatch(get_all_bank(_data_login.data.token));
            }
            if (permisos.filter(x => x.codigo === 'view_reasondismissal').length > 0) {
                dispatch(getAllReasonDismissal(_data_login.data.token));
            }
            // if (permisos.filter(x => x.codigo === 'view_forms').length > 0) {
            //     dispatch(get_all_form(_data_login.data.token));
            // }
            if (permisos.filter(x => x.codigo === 'view_sections').length > 0) {
                dispatch(get_all_section(_data_login.data.token));
            }

            if (permisos.filter(x => (x.codigo === 'view_sections' || x.codigo === 'view_fieldtypes')).length > 0) {
                dispatch(get_all_field_types(_data_login.data.token));
            }

            
            dispatch(getAllVisits(_data_login.data.token, userEstablishmentsList.establecimientos?.map((par) => par.id), 1));
            dispatch(getAllVisitsAndDepartures(_data_login.data.token, 1));
            dispatch(getAllDepartures(_data_login.data.token, userEstablishmentsList.establecimientos?.map((par) => par.id), 1));
            dispatch(getAllIncome(_data_login.data.token, userEstablishmentsList.establecimientos?.map((par) => par.id), 1)); */
            setToken(_data_login.data.token);
            // dispatch(get_all_general_settings(_data_login.data.token));
            // if (permisos.filter(x => (x.codigo === 'view_user' || x.codigo === 'view_group')).length > 0) {
            //     dispatch(get_all_permisions(_data_login.data.token));
            // }
        } else {
            history.push("/");
        }
    }, [dispatch, _data_login, history, userEstablishmentsList, permisos]);

    /* useEffect(() => {
        if (userEstablishmentsStatus >= 200) {
            dispatch(
                getAllDepartures(
                    _data_login.data.token,
                    userEstablishmentsList.establecimientos?.map((par) => par.id),
                    1
                )
            );
            dispatch(
                getAllVisits(
                    _data_login.data.token,
                    userEstablishmentsList.establecimientos?.map((par) => par.id),
                    1
                )
            );
            dispatch(
                getAllIncome(
                    _data_login.data.token,
                    userEstablishmentsList.establecimientos?.map((par) => par.id),
                    1
                )
            );
        }
    }, [
        _data_login.data.token,
        dispatch,
        userEstablishmentsList.establecimientos,
        userEstablishmentsStatus,
    ]); */

    useEffect(() => {
        handleMessageWs();
        // eslint-disable-next-line
    }, [socket]);

    // useEffect(() => {
    //   console.log(_session_data);
    //   // eslint-disable-next-line
    // }, [socket]);

    // const sleep = (ms) => {
    //     return new Promise(resolve => setTimeout(resolve, ms));
    // }

    let visit = false;
    let departure = false;
    let income = false;
    let custody = false;
    let shipping_request = false;
    let maintenance = false;
    let purchase = false;
    let novelty_vehicle_maintenance = false;
    let vacancies = false;
    let vehicle_maintenance = false;
    let monitoreo = false;
    let personal_departures = false;

    const handleMessageWs = () => {
        if (socket) {
            socket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                if (data.type === TYPE_UPDATE_MESSAGE && !visit) {
                    visit_update_message(data, socket);
                    return;
                }
                // if (data.type === TYPE_REPORT_GENERATE) {
                //   visit_report_generate(data, socket);
                // }
                // if (data.type === TYPE_REPORT_EMPLOYEE_GENERATE) {
                //   console.log("generar empleados");
                //   employee_report_generate(data, socket);
                // }
                // if (data.type === TYPE_REPORT_DEPARTURE_GENERATE) {
                //   console.log("generar reporte de salida de empleados");
                //   departures_report_generate(data, socket);
                // }
                // if (data.type === TYPE_REPORT_MONITORING_GENERATE) {
                //   console.log("generar reporte de monitoreo");
                //   monitoring_report_generate(data, socket);
                // }
                if (data.type === TYPE_CREATE_MESSAGE && !visit) {
                    visit_create_message(data, socket);
                }
                if (data.type === TYPE_UPDATE_DEPARTURE && !departure) {
                    departure_update_message(data);
                    return;
                }
                if (data.type === TYPE_CREATE_DEPARTURE && !departure) {
                    departure_create_message(data);
                }
                if (data.type === TYPE_INCOME_UPDATE_MESSAGE && !income) {
                    income_update_message(data);
                    return;
                }
                if (data.type === TYPE_INCOME_CREATE_MESSAGE && !income) {
                    income_create_message(data);
                }
                // if (data.type === TYPE_INCOME_REPORT_GENERATE) {
                //   console.log("generar reporte de monitoreo");
                //   income_report_generate(data, socket);
                // }

                if (data.type === TYPE_UPDATE_CUSTODY && !custody) {
                    custody_update_message(data);
                    return;
                }
                if (data.type === TYPE_CREATE_CUSTODY && !custody) {
                    custody_create_message(data);
                }
                if (data.type === TYPE_UPDATE_SHIPPING_REQUEST && !shipping_request) {
                    shipping_request_update_message(data);
                    return;
                }
                if (data.type === TYPE_CREATE_SHIPPING_REQUEST && !shipping_request) {
                    shipping_request_create_message(data);
                }
                if (data.type === TYPE_UPDATE_MAINTENANCE && !maintenance) {
                    maintenance_update_message(data);
                    return;
                }
                if (data.type === TYPE_CREATE_MAINTENANCE && !maintenance) {
                    maintenance_create_message(data);
                }
                if (data.type === TYPE_UPDATE_PURCHASE && !purchase) {
                    purchase_update_message(data);
                    return;
                }
                if (data.type === TYPE_CREATE_PURCHASE && !purchase) {
                    purchase_create_message(data);
                }
                if (data.type === TYPE_UPDATE_NOVELTY_VEHICLE_MAINTENANCE && !novelty_vehicle_maintenance) {
                    novelty_vehicle_maintenance_update_message(data);
                    return;
                }
                if (data.type === TYPE_CREATE_NOVELTY_VEHICLE_MAINTENANCE && !novelty_vehicle_maintenance) {
                    novelty_vehicle_maintenance_create_message(data);
                }
                if (data.type === TYPE_UPDATE_VEHICLE_MAINTENANCE && !vehicle_maintenance) {
                    vehicle_maintenance_update_message(data);
                    return;
                }
                if (data.type === TYPE_CREATE_VEHICLE_MAINTENANCE && !vehicle_maintenance) {
                    vehicle_maintenance_create_message(data);
                }
                if (data.type === TYPE_UPDATE_VACANCIES && !vacancies) {
                    vacancies_update_message(data);
                    return;
                }
                if (data.type === TYPE_CREATE_VACANCIES && !vacancies) {
                    vacancies_create_message(data);
                }

                if (data.type === TYPE_UPDATE_MONITOREO && !monitoreo) {
                    monitoreo_update_message(data);
                    return;
                }
                if (data.type === TYPE_UPDATE_PERSONAL_DEPARTURES && !personal_departures) {
                    personal_departures_update_message(data);
                    return;
                }
            };
        }
    };

    const monitoreo_update_message = (data, socket) => {
        monitoreo = true;
        toast.success(data.message);
        // const notification = {
        //     title: data.message,
        //     message: "",
        //     result: null,
        //     read: false,
        //     type: TYPE_CREATE_VACANCIES,
        //     show: true,
        // };
        // let n = _get_notification.data ?? [];
        // n.push(notification);
        // dispatch(save_notification(n));
        dispatch(getAllVisitsAndDepartures(token, 1));
        audio.play();
        monitoreo = false;
    };

    const personal_departures_update_message = (data, socket) => {
        personal_departures = true;
        toast.success(data.message);
        // const notification = {
        //     title: data.message,
        //     message: "",
        //     result: null,
        //     read: false,
        //     type: TYPE_CREATE_VACANCIES,
        //     show: true,
        // };
        // let n = _get_notification.data ?? [];
        // n.push(notification);
        // dispatch(save_notification(n));
        dispatch(getAllDeparturesPersonal(token, 1));
        audio.play();
        personal_departures = false;
    };

    const visit_update_message = (data, socket) => {
        visit = true;
        toast.success(data.message);
        // const notification = {
        //     title: data.title,
        //     message: data.message,
        //     result: null,
        //     read: false,
        //     type: TYPE_UPDATE_MESSAGE,
        //     show: true,
        //     date: data.date,
        // };
        // let n = _get_notification.data ?? [];
        // n.push(notification);
        // dispatch(save_notification(n));
        dispatch(getAllVisits(token, 1));
        audio.play();
        visit = false;
    };

    const visit_create_message = (data, socket) => {
        visit = true;
        dispatch(getAllVisits(token, 1));
        // dispatch(getAllVisitsAndDepartures(token, 1));
        visit = false;
    };

    const departure_update_message = (data, socket) => {
        departure = true;
        dispatch(getAllDepartures(token, 1));
        // dispatch(getAllDeparturesPersonal(token, 1));
        // dispatch(getAllVisitsAndDepartures(token, 1));
        if ((request_exit && request_exit.codigo === "request_exit") || (response_exit && response_exit.codigo === 'response_exit')) {
            toast.success(data.message);
            // const notification = {
            //     title: data.title,
            //     message: data.message,
            //     result: null,
            //     read: false,
            //     type: TYPE_UPDATE_DEPARTURE,
            //     show: true,
            //     date: data.date,
            // };
            // let n = _get_notification.data ?? [];
            // n.push(notification);
            // dispatch(save_notification(n));
        }
        audio.play();
        departure = false;
    };

    const departure_create_message = (data, socket) => {
        departure = true;
        if (aprove_departures && aprove_departures.codigo === "aprove_departures") {
            toast.success("Nueva salida creada");
            // const notification = {
            //     title: "Nueva salida creada",
            //     message: "",
            //     result: null,
            //     read: false,
            //     type: TYPE_CREATE_DEPARTURE,
            //     show: true,
            // };
            // let n = _get_notification.data ?? [];
            // n.push(notification);
            // dispatch(save_notification(n));
            audio.play();
            // console.log(data)
        } else {
            console.log(
                "userPermmission.aprove_departures not found",
                aprove_departures
            );
        }
        dispatch(getAllDepartures(token, 1));
        // dispatch(getAllDeparturesPersonal(token, 1));
        // dispatch(getAllVisitsAndDepartures(token, 1));
        departure = false;
    };

    const income_create_message = (data, socket) => {
        income = true;
        dispatch(getAllIncome(token, 1));
        // dispatch(getAllVisitsAndDepartures(token, 1));
        income = false;
    };

    const income_update_message = (data, socket) => {
        income = true;
        toast.success(data.message);
        // const notification = {
        //     title: data.title,
        //     message: data.message,
        //     result: null,
        //     read: false,
        //     type: TYPE_INCOME_UPDATE_MESSAGE,
        //     show: true,
        //     date: data.date,
        // };
        // let n = _get_notification.data ?? [];
        // n.push(notification);
        // dispatch(save_notification(n));
        dispatch(getAllIncome(token, 1));
        // dispatch(getAllVisitsAndDepartures(token, 1));
        audio.play();
        income = false;
    };

    const custody_create_message = (data, socket) => {
        custody = true;
        toast.success("Nueva custodia");
        const notification = {
            title: "Nueva custodia creada",
            message: "",
            result: null,
            read: false,
            type: TYPE_CREATE_CUSTODY,
            show: true,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllCustody(token, 1));
        audio.play();
        custody = false;
    };

    const custody_update_message = (data, socket) => {
        custody = true;
        toast.success(data.message);
        const notification = {
            title: data.title,
            message: data.message,
            result: null,
            read: false,
            type: TYPE_UPDATE_CUSTODY,
            show: true,
            date: data.date,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllCustody(token, 1));
        audio.play();
        custody = false;
    };

    const shipping_request_create_message = (data, socket) => {
        shipping_request = true;
        toast.success("Nueva solicitud de envío");
        const notification = {
            title: "Nueva solicitud creada",
            message: "",
            result: null,
            read: false,
            type: TYPE_CREATE_SHIPPING_REQUEST,
            show: true,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllShippingRequest(token));
        audio.play();
        shipping_request = false;
    };

    const shipping_request_update_message = (data, socket) => {
        shipping_request = true;
        toast.success(data.message);
        const notification = {
            title: data.title,
            message: data.message,
            result: null,
            read: false,
            type: TYPE_UPDATE_SHIPPING_REQUEST,
            show: true,
            date: data.date,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllShippingRequest(token));
        audio.play();
        shipping_request = false;
    };

    const maintenance_create_message = (data, socket) => {
        maintenance = true;
        toast.success("Nuevo mantenimiento");
        const notification = {
            title: "Nuevo mantenimiento",
            message: "",
            result: null,
            read: false,
            type: TYPE_CREATE_MAINTENANCE,
            show: true,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllMaintenance(token));
        audio.play();
        maintenance = false;
    };

    const maintenance_update_message = (data, socket) => {
        maintenance = true;
        toast.success(data.message);
        const notification = {
            title: data.title,
            message: data.message,
            result: null,
            read: false,
            type: TYPE_UPDATE_MAINTENANCE,
            show: true,
            date: data.date,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllMaintenance(token));
        audio.play();
        maintenance = false;
    };

    const purchase_create_message = (data, socket) => {
        purchase = true;
        toast.success("Nueva compra");
        const notification = {
            title: "Nueva compra",
            message: "",
            result: null,
            read: false,
            type: TYPE_CREATE_PURCHASE,
            show: true,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllPurchase(token));
        audio.play();
        purchase = false;
    };

    const novelty_vehicle_maintenance_update_message = (data, socket) => {
        novelty_vehicle_maintenance = true;
        toast.success(data.message);
        const notification = {
            title: data.title,
            message: data.message,
            result: null,
            read: false,
            type: TYPE_UPDATE_NOVELTY_VEHICLE_MAINTENANCE,
            show: true,
            date: data.date,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllNoveltyVehicleMaintenance(token));
        audio.play();
        novelty_vehicle_maintenance = false;
    };

    const novelty_vehicle_maintenance_create_message = (data, socket) => {
        novelty_vehicle_maintenance = true;
        toast.success("Nueva novedad de mantenimiento");
        const notification = {
            title: "Nueva novedad de mantenimiento",
            message: "",
            result: null,
            read: false,
            type: TYPE_CREATE_NOVELTY_VEHICLE_MAINTENANCE,
            show: true,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllNoveltyVehicleMaintenance(token));
        audio.play();
        novelty_vehicle_maintenance = false;
    };

    const vehicle_maintenance_update_message = (data, socket) => {
        vehicle_maintenance = true;
        toast.success(data.message);
        const notification = {
            title: data.title,
            message: data.message,
            result: null,
            read: false,
            type: TYPE_UPDATE_VEHICLE_MAINTENANCE,
            show: true,
            date: data.date,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllVehicle(token));
        audio.play();
        vehicle_maintenance = false;
    };

    const vehicle_maintenance_create_message = (data, socket) => {
        vehicle_maintenance = true;
        toast.success("Nuevo mantenimiento de vehículo");
        const notification = {
            title: "Nuevo mantenimiento de vehículo",
            message: "",
            result: null,
            read: false,
            type: TYPE_CREATE_VEHICLE_MAINTENANCE,
            show: true,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllVehicle(token));
        audio.play();
        vehicle_maintenance = false;
    };

    const vacancies_update_message = (data, socket) => {
        vacancies = true;
        toast.success(data.message);
        const notification = {
            title: data.title,
            message: data.message,
            result: null,
            read: false,
            type: TYPE_UPDATE_VACANCIES,
            show: true,
            date: data.date,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllVacancies(token));
        audio.play();
        vacancies = false;
    };

    const vacancies_create_message = (data, socket) => {
        vacancies = true;
        toast.success("Nueva vacante");
        const notification = {
            title: "Nueva vacante",
            message: "",
            result: null,
            read: false,
            type: TYPE_CREATE_VACANCIES,
            show: true,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllVacancies(token));
        audio.play();
        vacancies = false;
    };

    const purchase_update_message = (data, socket) => {
        purchase = true;
        toast.success(data.message);
        const notification = {
            title: data.title,
            message: data.message,
            result: null,
            read: false,
            type: TYPE_UPDATE_PURCHASE,
            show: true,
            date: data.date,
        };
        let n = _get_notification.data ?? [];
        n.push(notification);
        dispatch(save_notification(n));
        dispatch(getAllPurchase(token));
        audio.play();
        purchase = false;
    };

    /* let timer_income = null;

    const income_report_generate = (data, socket) => {
      timer_income = setInterval(() => {
        check_export_income_status(token, data.id_task)
          .then((e) => {
            let datos = e.data;
            console.log(datos);
            if (e.status === 200) {
              dispatch(clearIncome(GET_REPORT_INCOME));
              const notification = {
                title: "Reporte Generado ",
                message: datos.result.nombre,
                result: datos.result,
                id: datos.id_task,
                read: false,
                date: datos.date,
                type: TYPE_INCOME_REPORT_GENERATE,
                show: true,
              };
              let n = _get_notification.data ?? [];
              n.push(notification);
              dispatch(save_notification(n));
              audio.play();
              clearInterval(timer_income);
              timer_income = null;
            }
          })
          .catch((e) => {
            clearInterval(timer_income);
            timer_income = null;
          });
      }, 5000);
    };

    let timer = null;

    const visit_report_generate = (data, socket) => {
      console.log("reporte");
      console.log(data.id_task);
      timer = setInterval(() => {
        check_export_status(token, data.id_task)
          .then((e) => {
            let datos = e.data;
            console.log(datos);
            if (e.status === 200) {
              dispatch(clearVisit(GET_REPORT));
              const notification = {
                title: "Reporte Generado ",
                message: datos.result.nombre,
                result: datos.result,
                id: datos.id_task,
                read: false,
                date: datos.date,
                type: TYPE_REPORT_GENERATE,
                show: true,
              };
              let n = _get_notification.data ?? [];
              n.push(notification);
              dispatch(save_notification(n));
              audio.play();
              clearInterval(timer);
              timer = null;
            }
          })
          .catch((e) => {
            clearInterval(timer);
            timer = null;
          });
      }, 5000);
    };

    let timer_employee = null;
    const employee_report_generate = (data, socket) => {
      timer_employee = setInterval(() => {
        check_export_employee_status(token, data.id_task)
          .then((e) => {
            let datos = e.data;
            if (e.status === 200) {
              dispatch(clear_employee(GET_REPORT_EMPLOYEE));
              const notification = {
                title: "Reporte Generado ",
                message: datos.result.nombre,
                result: datos.result,
                id: datos.id_task,
                read: false,
                date: datos.date,
                type: TYPE_REPORT_EMPLOYEE_GENERATE,
                show: true,
              };
              let n = _get_notification.data ?? [];
              n.push(notification);
              dispatch(save_notification(n));

              audio.play();
              clearInterval(timer_employee);
              timer_employee = null;
            }
          })
          .catch((e) => {
            clearInterval(timer_employee);
            timer_employee = null;
          });
      }, 5000);
    };


    let timer_departure = null;
    const departures_report_generate = (data, socket) => {
      timer_departure = setInterval(() => {
        check_export_departures_status(token, data.id_task)
          .then((e) => {
            let datos = e.data;
            if (e.status === 200) {
              dispatch(clearDeparture(GET_REPORT_DEPARTURE));
              const notification = {
                title: "Reporte Generado ",
                message: datos.result.nombre,
                result: datos.result,
                id: datos.id_task,
                read: false,
                date: datos.date,
                type: TYPE_REPORT_DEPARTURE_GENERATE,
                show: true,
              };
              let n = _get_notification.data ?? [];
              n.push(notification);
              dispatch(save_notification(n));

              audio.play();
              clearInterval(timer_departure);
              timer_departure = null;
            }
          })
          .catch((e) => {
            clearInterval(timer_departure);
            timer_departure = null;
          });
      }, 5000);
    };

    let timer_monitoring = null;
    const monitoring_report_generate = (data, socket) => {
      timer_monitoring = setInterval(() => {
        check_export_monitoring_status(token, data.id_task)
          .then((e) => {
            let datos = e.data;
            if (e.status === 200) {
              dispatch(clearVisit(GET_REPORT_MONITORING));
              const notification = {
                title: "Reporte Generado ",
                message: datos.result.nombre,
                result: datos.result,
                id: datos.id_task,
                read: false,
                date: datos.date,
                type: TYPE_REPORT_MONITORING_GENERATE,
                show: true,
              };
              let n = _get_notification.data ?? [];
              n.push(notification);
              dispatch(save_notification(n));

              audio.play();
              clearInterval(timer_monitoring);
              timer_monitoring = null;
            }
          })
          .catch((e) => {
            clearInterval(timer_monitoring);
            timer_monitoring = null;
          });
      }, 5000);
    };
   */
    return (
        <Router>
            <div className='header-navbar-shadow'/>
            <Navbar/>
            <Sidebar/>
            <Switch>
                {/*eslint-disable-next-line*/}
                {route.map((item, index) => {
                    if (!item.meta.requiresAuth) {
                        return (
                            <Route path={item.path} exact={item.exact}>
                                {<item.component {...permisos} />}
                            </Route>
                        );
                    }

                    if (
                        permisos.filter((x) =>
                            item.meta.permission_required.includes(x.codigo)
                        ).length > 0
                    ) {
                        return (
                            <Route path={item.path} exact={item.exact}>
                                {<item.component {...permisos} />}
                            </Route>
                        );
                    }
                })}
            </Switch>
        </Router>
    );
};
export default Index;
